import { render, staticRenderFns } from "./AppProfile.vue?vue&type=template&id=b6da0454&scoped=true"
import script from "./AppProfile.vue?vue&type=script&lang=js"
export * from "./AppProfile.vue?vue&type=script&lang=js"
import style0 from "./AppProfile.vue?vue&type=style&index=0&id=b6da0454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6da0454",
  null
  
)

export default component.exports